import { Injector } from '@angular/core';

export enum ModalState {
  OPEN,
  DESTROY,
  CLOSE,
}

export class ActionWindowModel {
  constructor(component: any, dataContext: any, injector: Injector, providers?: any, wide?: boolean) {
    this.component = component;
    this.dataContext = dataContext;
    this.injector = injector;
    this.providers = providers;
    this.wide = wide;
  }

  readonly component: any;
  readonly dataContext: any;
  readonly injector: Injector;
  readonly providers: any;
  readonly wide: boolean;
}
